/**
 * HTTP 请求库
 * @Description: 用于处理全局 HTTP 请求
 *
 * @Author: JZT.Oscar
 * @Date: 2018-09-26 20:40:40
 * @Last Modified by: JZT.lmy
 * @Last Modified time: 2018-11-16 16:49:33
 */
import axios from "axios";
import qs from "qs";
import router from "@/router";
import { message } from "ant-design-vue";
import { getCurrentServiceDomain, isUploadFile } from "@/libs/common";
import { EnvConf } from "@/libs/config";
import Cookie from '@/libs/utils/cookie'

// 头类型
const CONTENT_TYPE_FORMDATA = "application/x-www-form-urlencoded;charset=UTF-8";
const CONTENT_TYPE_JSON = "application/json;charset=UTF-8";

// 生产环境使用测试域名
if (process.env.NODE_ENV === "production") {
    axios.defaults.baseURL = `${getCurrentServiceDomain()}`;
    axios.defaults.withCredentials = true;
} else if (EnvConf.mockServer.enabled) {
    axios.defaults.baseURL = EnvConf.mockServer.baseUrl;
}
// 配置请求头,不配置则默认是JSON
axios.defaults.headers.post["Content-Type"] = CONTENT_TYPE_FORMDATA;

// 请求拦截器
axios.interceptors.request.use(
    config => {
        // 全局拦截，解决客户账号，店铺账号互串漏洞
        let userType = localStorage.getItem('userType')
        // console.log(config)
        // if (config.url !== '/user/login' && userType === 'R07') {
        //     location.href = '/'
        //     return config
        // }
        // 增加时间戳
        if (config.method === "get") {
            config.params = {
                _t: new Date().valueOf(),
                ...config.params
            };
            return config;
        }
        // 是否为 POST JSON 请求
        if (
            config.headers.post &&
            config.headers.post["Content-Type"] &&
            config.headers.post["Content-Type"].indexOf("application/json") > -1
        ) {
            return config;
        }
        // POST传参序列化(展示注释，在确认采用JSON 或 FormData方式后再考虑)
        // 增加判断表单上传文件时，不进行参数序列化
        if (config.method === "post" && !isUploadFile(config)) {
            config.data = qs.stringify(config.data);
        }
        return config;
    },
    error => {
        // 错误提示
        // UNDONE：错误文本目前未确定字段
        message.error(error);

        return Promise.reject(error);
    }
);

let env = process.env.NODE_ENV
// 响应拦截器
axios.interceptors.response.use(
    res => {
        let routeName = router.currentRoute.name
        if (env === 'development') {
            return res.data
        }
        let userType = localStorage.getItem('userType')
        if (userType === 'R07' && routeName !== 'authentication' && routeName !== 'index') {
            // location.href = '/sass/index'
            router.replace({ name: 'index' })
            return res.data
        }
        return res.data
    },
    error => {
        if (error && error.response) {
            switch (error.response.status) {
                case 400:
                    error.message = "错误请求";
                    break;
                case 401:
                    error.message = "未授权，请重新登录";
                    // 不同环境切换到不同的登录页
                    // if (process.env.NODE_ENV === "production") {
                    //     window.location.href = `${getCurrentServiceDomain()}/user/login.htm`;
                    // } else {
                    //     router.push({
                    //         path: "/login"
                    //     });
                    // }
                    router.push({
                        path: "/frontPage/login"
                    });
                    break;
                case 403:
                    error.message = "拒绝访问";
                    break;
                case 404:
                    error.message = "请求错误,未找到该资源";
                    break;
                case 405:
                    error.message = "请求方法未允许";
                    break;
                case 408:
                    error.message = "请求超时";
                    break;
                case 500:
                    //营销活动模块中，返回500的仍为有效response
                    if (error.response.data && error.response.data.data) {
                        return Promise.resolve(error.response.data);
                    }
                    error.message = "服务器端出错";
                    break;
                case 501:
                    error.message = "网络未实现";
                    break;
                case 502:
                    error.message = "网络错误";
                    break;
                case 503:
                    error.message = "服务不可用";
                    break;
                case 504:
                    error.message = "网络超时";
                    break;
                case 505:
                    error.message = "http版本不支持该请求";
                    break;
                default:
                    error.message = `连接错误，错误码：${
                        error.response.status
                    }`;
            }
        } else {
            error.message = "连接到服务器失败";
        }

        // 提示错误
        message.error(error.message);

        return Promise.reject(error);
    }
);

// 扩展一个 POST JSON 方法
// 使用 POST 请求，发送 JSON 数据
axios.postJson = function(url, data, config) {
    return new Promise((resolve, reject) => {
        axios
            .post(url, data, {
                headers: {
                    post: {
                        "Content-Type": CONTENT_TYPE_JSON
                    }
                },
                ...config
            })
            .then(
                response => {
                    resolve(response);
                },
                err => {
                    reject(err);
                }
            )
            .catch(error => {
                reject(error);
            });
    });
};

export default axios;



// WEBPACK FOOTER //
// ./src/libs/axios.js